import React, { useState } from "react";
import "./VinylFlip.css";
// import frontCover from "../../assets/CoversFront/cover3.png";
// import backCover from "../../assets/CoversBack/cover2.png";
import NoImage from "../../assets/no-track.avif";

// VinylFlip.jsx
export default function VinylFlip({ frontSrc, backSrc }) {
  const [frontBroken, setFrontBroken] = useState(false);
  const [backBroken, setBackBroken] = useState(false);

  const getValidSrc = (src) => {
    const value = (src || "").trim();
    if (!value || value.toLowerCase() === "n/a") {
      return null;
    }
    return value;
  };

  const validFront = getValidSrc(frontSrc);
  const validBack = getValidSrc(backSrc);

  const finalFront = validFront && !frontBroken ? validFront : NoImage;
  const finalBack = validBack && !backBroken ? validBack : null;

  const hasBack = !!finalBack;

  return (
    <section className="vinyl-section">
      <div className="vinyl-flip">
        <div className={`vinyl-flip-inner ${!hasBack ? "noFlip" : ""}`}>
          <img
            src={finalFront}
            alt="Vinyl Front"
            className="vinyl-face vinyl-front"
            onError={(e) => {
              setFrontBroken(true);
              e.currentTarget.onerror = null;
              e.currentTarget.src = NoImage;
            }}
          />

          {hasBack && (
            <img
              src={finalBack}
              alt="Vinyl Back"
              className="vinyl-face vinyl-back"
              onError={() => {
                setBackBroken(true);
              }}
            />
          )}
        </div>

        <div
          className={`vinyl-table-shadow-tr shadow-front-tr ${
            !hasBack ? "noHide" : ""
          }`}
        ></div>

        {hasBack && (
          <div className="vinyl-table-shadow-tr shadow-back-tr"></div>
        )}
      </div>
    </section>
  );
}